export default (state = INITIAL.user, action) => {
  return state
}
